import React, { useState, useRef } from 'react';
import ThemeToggle from './components/ThemeToggle';
import LanguageToggle from './components/LanguageToggle';
import { useT } from './LocaleContext';
import { useNavigate } from 'react-router-dom';
import { GlobalStyle, DropdownItem, MenuButton, DropdownMenu } from './styles/GlobalStyles';
import { useOutsideClick, validateEmail, getErrorMessage, formatUserMessage } from './common';
import { authAPI } from './api';
import { 
  ForgotPasswordContainer, 
  Title, 
  Form, 
  Input, 
  Button, 
  Message
} from './styles/ForgotPasswordPageStyles';


const ForgotPasswordPage = () => {
  const t = useT();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef, () => setMenuOpen(false));
  const toggleMenu = () => {setMenuOpen((prev) => !prev);};

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const emailValidation = validateEmail(email.trim());
    if (!emailValidation.valid) {
      setMessage({ text: emailValidation.message, success: false });
      return;
    }

    try {
      const response = await authAPI.passwordForgot(email.trim());
      const msg = response.data.msg || t('forgotPassword.codeSent');
      setMessage({ 
        text: t('forgotPassword.checkEmail', { message: formatUserMessage(msg) }), 
        success: true 
      });
      
      setTimeout(() => {
        navigate('/password-reset', { state: { email: email.trim() } });
      }, 3000);
    } catch (error) {
      const errorMessage = getErrorMessage(error, t('common.unknownError'));
      setMessage({
        text: t('common.errorPrefix', { message: errorMessage }),
        success: false,
      });
    }
  };

  return (
    <ForgotPasswordContainer>
      <GlobalStyle />
      {message && <Message success={message.success}>{message.text}</Message>}
      <MenuButton onClick={toggleMenu} $open={menuOpen}>≡</MenuButton>
      <DropdownMenu ref={dropdownRef} open={menuOpen}>
        <DropdownItem to="/">{t('nav.home')}</DropdownItem>
        <DropdownItem to="/login">{t('nav.login')}</DropdownItem>
        <DropdownItem to="/register">{t('nav.register')}</DropdownItem>
        <ThemeToggle />
        <LanguageToggle />
      </DropdownMenu>

      <Title>{t('forgotPassword.title')}</Title>
      <Form onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder={t('common.email')}
        value={email}
        maxLength={254}
        autoComplete="email"
        onChange={(e) => setEmail(e.target.value.trim())}
        disabled={!!message?.success}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && email && !message?.success) {
            e.preventDefault();
            handleSubmit(e);
          }
        }}
        style={message?.success ? {
          backgroundColor: '#f5f5f5',
          cursor: 'not-allowed',
          opacity: 0.7
        } : {}}
      />
      <Button type="submit" disabled={!!message?.success}>
        {message?.success ? t('forgotPassword.redirecting') : t('common.submit')}
      </Button>
    </Form>
    </ForgotPasswordContainer>
  );
};

export default ForgotPasswordPage;
